import React from 'react';
import PropTypes from 'prop-types';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import {schemaValidate, minLength, maxLength} from '../../../helpers/validation-helpers';
/* Components */
import Modal from '../../common/modal/modal';
import Input from '../../common/form-elements/input/input';
import Textarea from '../../common/form-elements/textarea/textarea';
import FormErrorMessage from '../../common/form-elements/form-error-message/form-error-message';

class DashboardInfoSettingsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dashboardName: this.props.dashboardName,
      dashboardDescription: this.props.dashboardDescription,
    };
  }

  handleSave = (values) => {
    this.props.onSave(values);
    this.props.onClose();
  };

  closeAndDiscard = () => {
    this.props.onClose();
  };

  render() {
    return (
      <Modal.Default isOpen={this.props.isOpen}>
        <Formik
          initialValues={{
            dashboardName: this.state.dashboardName,
            dashboardDescription: this.state.dashboardDescription,
          }}
          onSubmit={this.handleSave}
        >
          {(props) => {
            return (
              <Form>
                <div className="glu-modal__header glu-flex glu-flex-align-center">
                  <div className="glu-modal__title glu-flex-grow">Edit name and description</div>
                  <div className="glu-flex-shrink">
                    <button
                      aria-label="close"
                      type="button"
                      className="glu-btn-link g-icon g-icon-close"
                      onClick={this.closeAndDiscard}
                    />
                  </div>
                </div>
                <div className="glu-modal__body">
                  <div className="glu-content__section">
                    <div className="glu-form-row">
                      <label className="glu-label">Dashboard name</label>
                      <Field
                        as={Input}
                        onChange={props.handleChange('dashboardName')}
                        autoFocus
                        name="dashboardName"
                        validate={schemaValidate([minLength(), maxLength(50)])}
                        invalid={props.errors.dashboardName && props.touched.dashboardName}
                        className="glu-form-input-pad"
                      />
                      <ErrorMessage name="dashboardName" component={FormErrorMessage} />
                    </div>
                    <div className="glu-form-row">
                      <label className="glu-label">Description</label>
                      <Field
                        as={Textarea}
                        onChange={props.handleChange('dashboardDescription')}
                        placeholder="Enter Dashboard Description"
                        name="dashboardDescription"
                        validate={schemaValidate(maxLength(250))}
                        invalid={
                          props.errors.dashboardDescription && props.touched.dashboardDescription
                        }
                        maxChar={250}
                        className="glu-form-input-pad"
                      />
                      <ErrorMessage name="dashboardDescription" component={FormErrorMessage} />
                    </div>
                  </div>
                </div>
                <footer className="glu-modal__footer">
                  <div className="glu-flex-grow glu-flex-row">
                    <div className="glu-flex-grow text-right">
                      <button
                        type="button"
                        onClick={this.closeAndDiscard}
                        className="glu-btn glu-btn--secondary"
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="glu-flex-shrink">
                      <button className="glu-btn glu-btn--primary" type="submit">
                        Save
                      </button>
                    </div>
                  </div>
                </footer>
              </Form>
            );
          }}
        </Formik>
      </Modal.Default>
    );
  }
}

DashboardInfoSettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  dashboardDescription: PropTypes.string.isRequired,
  dashboardName: PropTypes.string.isRequired,
};

export default DashboardInfoSettingsModal;
